/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Binding_D1_DetailInputs */

const en_marketing_binding_d1_detail = /** @type {(inputs: Marketing_Binding_D1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relational data behind a typed Drizzle schema.`)
};

const es_marketing_binding_d1_detail = /** @type {(inputs: Marketing_Binding_D1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos relacionales tras un esquema de Drizzle tipado.`)
};

const fr_marketing_binding_d1_detail = /** @type {(inputs: Marketing_Binding_D1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données relationnelles derrière un schéma Drizzle typé.`)
};

/**
* | output |
* | --- |
* | "Relational data behind a typed Drizzle schema." |
*
* @param {Marketing_Binding_D1_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_binding_d1_detail = /** @type {((inputs?: Marketing_Binding_D1_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Binding_D1_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_binding_d1_detail(inputs)
	if (locale === "es") return es_marketing_binding_d1_detail(inputs)
	return fr_marketing_binding_d1_detail(inputs)
});